import { ChangeDetectorRef } from "@angular/core"
import { Observable, debounceTime, Subject, takeUntil, distinctUntilChanged, switchMap, tap } from "rxjs"

export interface SearchSuggestion {
    id: string,
    value: string
}

export abstract class AutocompleteStrategyBase {

    constructor() {
    }

    public loadSuggestions$(e: string, maxSuggestions: number | undefined = undefined): Observable<SearchSuggestion[]> {
        console.warn('using loadSuggestions$ base function, must override it');
        return new Observable<SearchSuggestion[]>();
    }
}